import FlightStatus from './components/FlightStatus/FlightStatus.css';
const theme = {
    FlightStatus: {
        Header: {
            closeIcon: FlightStatus.closeIcon,
            input: FlightStatus.input,
            input_filled: FlightStatus.input_filled
        },
        FlightListItem: {
            controls: FlightStatus.flightListItem__controls,
            bookLink: FlightStatus.flightListItem__bookLink,
            airportsInfo: FlightStatus.airportsInfo,
            airportInfo: FlightStatus.airportInfo,
            departure: FlightStatus.departure,
            arrival: FlightStatus.arrival,
            scheduled: FlightStatus.scheduled
        }
    },
    Amenities: {
        Amenities: {
            amenities__item: FlightStatus.amenities__item,
            amenities__item_unavailable: FlightStatus.amenities__item_unavailable
        }
    }
};
export default theme;
